import AuthController from '../domain/controller.js'
import { EVENTS } from '../utils/constants.js'
import saveUserInLocalData from './saveUserInLocalData.js'
import InactivityTracker from '../utils/inactivityTracker.js'

async function makeLogout(context, payload) {
  console.log('🚀 ~ makeLogout ~ payload:', payload)
  const { events, localRepo, sendBugAlert } = context

  try {
    const user = await AuthController.deleteUserData(localRepo)
    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: `You are logged out`,
      body: `See you soon ${user?.firstName || ''}!`,
    })
  } catch (error) {
    let title = 'Logout error'
    let body =
      'We are unable to log you out. Please try again later. Our team has already been notified of the issue.'
    sendBugAlert(error)
    console.log('🚀 ~ makeLogout ~ error:', error)
    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
    return
  }

  // Effacer le compteur d'inactivité à la déconnexion
  InactivityTracker.clear()

  await saveUserInLocalData(context)
  events.dispatch(EVENTS.USER_DISCONNECTED)
  
  // Explicit redirection to login page
  if (typeof window !== 'undefined') {
    window.location.href = '/login'
  }
}

export default makeLogout
